<template>
  <div class="hub-actions">
    <button v-if="editable" type="button" class="hub-action hub-action-edit" @click="$emit('edit')">
      <font-awesome-icon icon="fa-solid fa-pen-to-square" />
      {{ editLabel }}
    </button>
    <button v-if="replaceable" type="button" class="hub-action hub-action-replace" @click="$emit('replace')">
      <font-awesome-icon icon="fa-solid fa-rotate" />
      {{ replaceLabel }}
    </button>
    <button v-if="cancellable" type="button" class="hub-action hub-action-cancel" @click="$emit('cancel')">
      {{ cancelLabel }}
    </button>
    <button v-if="createable" type="button" class="hub-action hub-action-create" @click="$emit('create')">
      {{ createLabel }}
    </button>
    <button v-if="deletable" type="button" class="hub-action hub-action-delete" :disabled="disabled" @click="$emit('delete')">
      <font-awesome-icon icon="fa-solid fa-trash" />
      {{ deleteLabel }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'ExecutorHubActions',
  props: {
    editable: { type: Boolean, default: false },
    replaceable: { type: Boolean, default: false },
    cancellable: { type: Boolean, default: false },
    createable: { type: Boolean, default: false },
    deletable: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    editLabel: { type: String, default: 'Редактировать' },
    replaceLabel: { type: String, default: 'Заменить' },
    cancelLabel: { type: String, default: 'Отменить' },
    createLabel: { type: String, default: 'Создать' },
    deleteLabel: { type: String, default: 'Удалить' },
  },
  emits: ['edit', 'replace', 'cancel', 'create', 'delete'],
}
</script>

<style scoped>
.hub-actions {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 14px;
}

.hub-action {
  align-items: center;
  background: #fff;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  color: #374151;
  cursor: pointer;
  display: inline-flex;
  font-size: 11px;
  font-weight: 600;
  gap: 6px;
  padding: 4px 8px;
  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.hub-action-edit:hover:not(:disabled) {
  border-color: #2563eb;
  color: #2563eb;
}

.hub-action-replace {
  border-color: #4f46e5;
  color: #4f46e5;
}

.hub-action-create {
  border-color: #2563eb;
  color: #2563eb;
}

.hub-action-create:hover:not(:disabled) {
  background: #2563eb;
  color: #fff;
}

.hub-action-replace:hover:not(:disabled) {
  background: #4f46e5;
  color: #fff;
}

.hub-action-cancel:hover:not(:disabled) {
  border-color: #dc3545;
  color: #dc3545;
}

.hub-action-delete {
  border-color: #c45c5c;
  color: #b42318;
}

.hub-action-delete:hover:not(:disabled) {
  background: #b42318;
  border-color: #b42318;
  color: #fff;
}

.hub-action:disabled {
  cursor: not-allowed;
  opacity: 0.65;
}
</style>
